// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckMark_wrapper__Q6pGX","animated_check":"CheckMark_animated_check__fNh7V","draw":"CheckMark_draw__+pWoO"};